import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import useHttp from "../../../hook/use-http";
import moment from "moment";
import { ThreeCircles } from "react-loader-spinner";
import { Chart } from "react-google-charts";
import NoData_Jupiter from "./NoData_Jupiter";
import ChartLoader_Jupiter from "./ChartLoader_Jupiter";
import { API_URL_MAIN } from "../../../constants/driveglobalfilterinitalstates";
import BuketsTable_Jupiter from "./BuketsTable_Jupiter";
import * as $ from "jquery";

function BcsActiveTime_Jupiter({ apiend, gloablfilter, title }) {
  const [chartdata, setChartData] = useState([]);
  const [apiresponce, SetApiResponce] = useState([]);
  const [filteredData, SetfilteredData] = useState([]);
  const { isLoading, error, sendReq: fetchData } = useHttp();
  let modal_title = title;

  const appyData = (data) => {
    // console.log("API Response:", data); // Debug log
    const res_result = data;

    let responce = {
      "0-10": 0,
      "10-20": 0,
      "20-30": 0,
      "30-40": 0,
      "40-50": 0,
      "50-60": 0,
      "60-70": 0,
      "70-80": 0,
      "80-90": 0,
      "90-100": 0,
      "Invalid/Negative": 0, // Handle -1 and other negative values
    };

    if (res_result && res_result.length > 0) {
      SetApiResponce(res_result);

      res_result.forEach((d) => {
        // Check if the required properties exist
        if (!d.discharge_cycle || !d.deltaOdo || !d.Range || !d.Range.values) {
          // console.warn("Missing required properties in data:", d);
          return;
        }

        // Apply filters
        if (
          d.discharge_cycle.doc_count > gloablfilter.DISCHARGE &&
          (d.deltaOdo.value === 0
            ? d.deltaOdo.value >= gloablfilter.DELTA
            : d.deltaOdo.value > gloablfilter.DELTA)
        ) {
          let value = d.Range.values["50.0"];
          // console.log("Processing value:", value, "for vehicle:", d.key.vehicleId); // Debug log

          // Handle the categorization including negative values
          if (value < 0) {
            responce["Invalid/Negative"] = responce["Invalid/Negative"] + 1;
          } else if (value >= 0 && value < 10) {
            responce["0-10"] = responce["0-10"] + 1;
          } else if (value >= 10 && value < 20) {
            responce["10-20"] = responce["10-20"] + 1;
          } else if (value >= 20 && value < 30) {
            responce["20-30"] = responce["20-30"] + 1;
          } else if (value >= 30 && value < 40) {
            responce["30-40"] = responce["30-40"] + 1;
          } else if (value >= 40 && value < 50) {
            responce["40-50"] = responce["40-50"] + 1;
          } else if (value >= 50 && value < 60) {
            responce["50-60"] = responce["50-60"] + 1;
          } else if (value >= 60 && value < 70) {
            responce["60-70"] = responce["60-70"] + 1;
          } else if (value >= 70 && value < 80) {
            responce["70-80"] = responce["70-80"] + 1;
          } else if (value >= 80 && value < 90) {
            responce["80-90"] = responce["80-90"] + 1;
          } else if (value >= 90 && value <= 100) {
            responce["90-100"] = responce["90-100"] + 1;
          }
        }
      });

      // console.log("Bucket counts:", responce); // Debug log

      // Format data for Google Charts
      let res_result_final = [["Element", "Count", { role: "style" }]];
      Object.keys(responce).forEach((x) => {
        res_result_final.push([
          x,
          responce[x],
          "stroke-width: 1;stroke-color: black;color:#348393",
        ]);
      });

      // console.log("Chart data:", res_result_final); // Debug log

      // Check if we have any data to display
      const hasData = Object.values(responce).some(count => count > 0);
      if (hasData) {
        setChartData(res_result_final);
      } else {
        // console.log("All bucket counts are 0 - no data to display");
        setChartData([]);
      }
    } else {
      // console.log("No data received or empty array");
      setChartData([]);
      SetApiResponce([]);
    }
  };

  const options = {
    hAxis: {
      gridlines: {
        color: "transparent",
      },
      title: "Median BCS Active Time Percent",
      minValue: 0,
      format: "short",
      textStyle: {
        fontSize: 8, // Adjust the font size as needed
      },
      slantedText: true, // Enable slanted text
      slantedTextAngle: 60, // Rotate labels to vertical (90 degrees)
    },
    vAxis: {
      gridlines: {
        color: "transparent",
      },
      title: "Vehicle Count",
      minValue: 0,
      format: "short",
    },
    bar: { groupWidth: "100%" },
    legend: "none",
  };

  useEffect(() => {
    fetchData(
      {
        url: API_URL_MAIN + "jupiter_drive_analysis/" + apiend,
        body: { filterdata: gloablfilter },
      },
      appyData
    );
  }, [gloablfilter]);

  return (
    <>
      <div className="v-title chartbox drive_graph p-0">
        <div className="titlebg titlebd_drive box_title pb-2 pt-2">{title}</div>
        <div className="chartHGT">
          {isLoading ? (
            <ChartLoader_Jupiter />
          ) : !chartdata || chartdata.length <= 1 ? (
            <NoData_Jupiter />
          ) : (
            <Chart
              chartType="ColumnChart"
              width="100%"
              height="247px"
              data={chartdata}
              options={options}
              chartEvents={[
                {
                  eventName: "select",
                  callback: ({ chartWrapper }) => {
                    const chart = chartWrapper.getChart();
                    const selection = chart.getSelection();
                    if (selection.length === 1) {
                      const [selectedItem] = selection;
                      const { row } = selectedItem;

                      const barLabel = chartWrapper.getDataTable().Wf[row].c[0].v;
                      const count = chartWrapper.getDataTable().Wf[row].c[1].v;

                      let filtered_temp = [];
                      if (count > 0) {
                        filtered_temp = apiresponce.filter((x) => {
                          if (
                            x.discharge_cycle.doc_count > gloablfilter.DISCHARGE &&
                            (x.deltaOdo.value === 0
                              ? x.deltaOdo.value >= gloablfilter.DELTA
                              : x.deltaOdo.value > gloablfilter.DELTA)
                          ) {
                            let value = x.Range.values["50.0"];

                            // Filter based on the selected bar label
                            switch (barLabel) {
                              case "Invalid/Negative":
                                return value < 0;
                              case "0-10":
                                return value >= 0 && value < 10;
                              case "10-20":
                                return value >= 10 && value < 20;
                              case "20-30":
                                return value >= 20 && value < 30;
                              case "30-40":
                                return value >= 30 && value < 40;
                              case "40-50":
                                return value >= 40 && value < 50;
                              case "50-60":
                                return value >= 50 && value < 60;
                              case "60-70":
                                return value >= 60 && value < 70;
                              case "70-80":
                                return value >= 70 && value < 80;
                              case "80-90":
                                return value >= 80 && value < 90;
                              case "90-100":
                                return value >= 90 && value <= 100;
                              default:
                                return false;
                            }
                          }
                          return false;
                        });

                        // Sort the filtered data
                        filtered_temp.sort((a, b) => {
                          const valueA = a.Range.values["50.0"];
                          const valueB = b.Range.values["50.0"];
                          return valueB - valueA; // Descending order
                        });

                        SetfilteredData(filtered_temp);
                        window.$("#exampleModal__" + apiend).modal("show");
                      }
                    }
                  },
                },
              ]}
            />
          )}

          <div
            className="modal fade"
            id={"exampleModal__" + apiend}
            tabIndex={-1}
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="exampleModalLabel">
                    {modal_title}
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  />
                </div>
                <div
                  className="modal-body"
                  style={{ overflowY: "scroll", height: "250px" }}
                >
                  <table className="table table-striped">
                    <thead
                      style={{ backgroundColor: "#32879c", color: "#fff" }}
                    >
                      <tr>
                        <th scope="col">Vin Number</th>
                        <th scope="col">Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <BuketsTable_Jupiter data={filteredData} />
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default BcsActiveTime_Jupiter;